import React from 'react';
import { FormHelperText } from '@material-ui/core';

interface IProps {
  type?: 'default' | 'error';
  formWarns: { key: string; message: string }[];
}

const SubInputWarn: React.FC<IProps> = ({ type = 'default', formWarns }) => {
  return (
    <div style={{marginBottom: 10}}>
      {formWarns.map((item) => (
        <FormHelperText error={type === 'error'}> {item.message}</FormHelperText>
      ))}
    </div>
  );
};

export default SubInputWarn;
